/* Engravita v7 · category navigation (Steven, 1 Nov 2026). Markup: snippets/eg-mega (desktop), snippets/eg-mb-browse
   (the drawer's Kategorier tab); styles: eg7-nav.css. Loaded deferred by eg7-head.
   1. Mega-menu: one main category open at a time. A mouse opens it on hover after a short pause, a longer one while
      the pointer heads right towards the open pane, so crossing the rows below on the way does not switch it. Click,
      Enter/Space and the arrow keys open it too.
   2. Drawer: Kalles fetches the drawer from /search?view=mn, so Liquid cannot tell which category the shopper is in.
      When the drawer opens, the main category holding this page opens and its tile is marked. */
(function () {
  'use strict';

  /* 1. mega-menu */
  var timer, x0 = 0, y0 = 0, x1 = 0, y1 = 0;
  function show(btn) {
    var root = btn.closest('[data-eg-mm]');
    if (!root) return;
    root.querySelectorAll('.eg-mm__cat').forEach(function (b) {
      var on = b === btn, pane = document.getElementById(b.getAttribute('aria-controls'));
      b.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (pane) pane.hidden = !on;
    });
    var start = root.querySelector('.eg-mm__start');
    if (start) start.hidden = true;
  }
  document.addEventListener('mousemove', function (e) { x0 = x1; y0 = y1; x1 = e.clientX; y1 = e.clientY; }, { passive: true });
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    var b = e.target.closest && e.target.closest('.eg-mm__cat');
    if (!b || b.getAttribute('aria-expanded') === 'true') return;
    var dx = x1 - x0, aiming = dx > 0 && Math.abs(y1 - y0) < dx * 2.5;
    clearTimeout(timer);
    timer = setTimeout(function () { show(b); }, aiming ? 260 : 80);
  });
  document.addEventListener('pointerout', function (e) {
    var b = e.target.closest && e.target.closest('.eg-mm__cat');
    if (b && !b.contains(e.relatedTarget)) clearTimeout(timer);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    var b = e.target.closest && e.target.closest('.eg-mm__cat');
    if (!b) return;
    e.preventDefault();
    var all = Array.prototype.slice.call(b.closest('[data-eg-mm]').querySelectorAll('.eg-mm__cat'));
    var next = all[(all.indexOf(b) + (e.key === 'ArrowDown' ? 1 : -1) + all.length) % all.length];
    next.focus();
    show(next);
  });

  /* 2. drawer: open the main category this page sits in */
  function clean(p) { return p.replace(/\/+$/, '').toLowerCase(); }
  function markDrawer() {
    var here = clean(location.pathname);
    if (here.indexOf('/collections/') !== 0) return;
    document.querySelectorAll('#menu-mb__cat .eg-mbx').forEach(function (row) {
      if (row.hasAttribute('data-eg-marked')) return;
      row.setAttribute('data-eg-marked', '');
      var hit = null;
      row.querySelectorAll('a[href]').forEach(function (a) { if (!hit && clean(a.pathname) === here) hit = a; });
      if (!hit) return;
      row.classList.add('is--current');
      var main = row.querySelector('details.eg-mbx__d');
      if (main) main.open = true;
      if (hit.classList.contains('eg-mbb__tile')) {
        hit.classList.add('is--current');
        hit.setAttribute('aria-current', 'page');
      }
      var group = hit.closest('.eg-mbb__xp > details');
      if (group) {
        group.open = true;
        var sum = group.querySelector('summary');
        if (sum) sum.classList.add('is--current');
      }
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.eg-mm__cat');
    if (b) { clearTimeout(timer); show(b); return; }
    if (e.target.closest && e.target.closest('[data-menu-drawer]')) { setTimeout(markDrawer, 0); setTimeout(markDrawer, 700); }
  });
})();
